import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: '/claimwizard',
    component: DashboardLayout,
    children: [
      {
        path: process.env.VUE_APP_VERSION,
        redirect: 'claimwizard',
        component: {
          render(c) { return c('router-view') }
        },
        children: [
          {
            path: 'claimwizard',
            alias: '/claimwizard',
            name: 'claimwizard',
            component: () => import(/* webpackChunkName: "demo" */ '../views/ClaimWizard/ClaimWizard.vue'),
            meta: {
              permission: [],
              requiresAuth: true
            }
          },
          {
            path: '/dashboard',
            name: 'dashboard',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
          },
          {
            path: '/icons',
            name: 'icons',
            component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
          },
          {
            path: '/profile',
            name: 'profile',
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue')
          },
          {
            path: '/maps',
            name: 'maps',
            component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue')
          },
          {
            path: '/tables',
            name: 'tables',
            component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue')
          }
        ]
      },
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/forgetpassword',
        name: 'forgetpassword',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Auth/ForgetPassword.vue')
      },
      {
        path: '/resetpassword',
        name: 'resetpassword',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Auth/ResetPassword.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
